import { useState, useEffect } from "react";
import { getMotivosEstudiante } from "../../services/apis_estudiante";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "clamp(0.5rem, 1rem, 1vh)",
    marginTop: "1rem",
  },
  button: {
    outline: "none",
    backgroundColor: "var(--color-inactive)",
    color: "var(--color-black)",
    border: "none",
    padding: "1rem 2rem",
    borderRadius: "8rem",
    cursor: "pointer",
    height: "auto",
    fontSize: "clamp(1rem, 2rem, 2vh)",
    fontWeight: 500,
    transition: "background-color 0.1s ease",
  },
  selected: {
    backgroundColor: "var(--color-primary)",
    color: "white",
    outline: "none",
  },
  error: {
    fontSize: "clamp(1rem, 2rem, 2vh)",
    color: "var(--bs-form-invalid-color)",
  },
};

function MotivosDeAtencion({ onSeleccion, error }) {
  const [motivos, setMotivos] = useState([]);
  const [motivoSeleccionado, setMotivoSeleccionado] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getMotivosEstudiante();
        setMotivos(data);
        console.log("Motivos cargados:", data);
      } catch (err) {
        console.error("No se pudieron cargar los motivos", err);
      }
    };
    fetchData();
  }, []);

  const handleSeleccion = (motivo) => {
    setMotivoSeleccionado(motivo);
    onSeleccion?.(motivo);
  };

  return (
    <div style={styles.container}>
      {motivos
        .filter((item) => item.activo !== false)
        .map((item) => (
          <button
            key={item.id}
            onClick={() => handleSeleccion(item.nombre)}
            style={
              item.nombre === motivoSeleccionado
                ? { ...styles.button, ...styles.selected }
                : styles.button
            }
            type="button"
          >
            {item.nombre}
          </button>
        ))}

      {error && <div style={styles.error}>{error}</div>}
    </div>
  );
}

export default MotivosDeAtencion;